// src/services/hotlapService.js
const apiKey = process.env.REACT_APP_API_KEY;
const BASE_URL = "https://api.simracing.co.uk/v0.1";

const eventTimings = {
  "The Lewie Hamilton": { Diamond: "1:32.500", Gold: "1:34.000", Silver: "1:36.000", Bronze: "1:40.000" },
  "Snowbird Special": { Diamond: "1:45.500", Gold: "1:47.000", Silver: "1:49.000", Bronze: "1:53.000" },
  "Big In Japan": { Diamond: "1:34.500", Gold: "1:36.000", Silver: "1:38.000", Bronze: "1:42.000" },
  "Stars & Stripes": { Diamond: "2:04.000", Gold: "2:05.000", Silver: "2:08.000", Bronze: "2:12.000" },
  "The 24": { Diamond: "3:30.000", Gold: "3:32.000", Silver: "3:38.000", Bronze: "3:46.000" },
  "Down Under": { Diamond: "2:10.000", Gold: "2:11.000", Silver: "2:14.000", Bronze: "2:20.000" },
  "Touge King": { Diamond: "2:18.000", Gold: "2:20.000", Silver: "2:24.000", Bronze: "2:32.000" },
  "F1 Legends": { Diamond: "1:25.000", Gold: "1:26.000", Silver: "1:28.000", Bronze: "1:32.000" },
  "Climb Dance": { Diamond: "8:30.000", Gold: "8:35.000", Silver: "8:45.000", Bronze: "9:00.000" },
  "The Ringmeister": { Diamond: "8:10.000", Gold: "8:15.000", Silver: "8:25.000", Bronze: "8:40.000" },
};

export const fetchAllHotlapEvents = async () => {
  try {
    const response = await fetch(`${BASE_URL}/hotlap_events`, {
      headers: { Authorization: `SRL ${apiKey}` },
    });
    const data = await response.text();
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(data, "text/xml");
    const eventsArray = Array.from(xmlDoc.getElementsByTagName("hotlap_event"));

    eventsArray.sort((a, b) => {
      const nameA = a.getElementsByTagName("name")[0]?.textContent || "";
      const nameB = b.getElementsByTagName("name")[0]?.textContent || "";
      return nameA.localeCompare(nameB, undefined, { numeric: true });
    });

    return eventsArray;
  } catch (error) {
    console.error("Error fetching hotlap events:", error);
    return [];
  }
};

export const fetchHotlapEventDetails = async (eventId) => {
  try {
    const response = await fetch(`${BASE_URL}/hotlap_events/${eventId}`, {
      headers: { Authorization: `SRL ${apiKey}` },
    });
    const data = await response.text();
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(data, "text/xml");

    // Extract all <result> elements
    const results = Array.from(xmlDoc.getElementsByTagName("result"));

    // Filter out invalid results
    const validResults = results.filter((result) => {
      const invalidTag = result.getElementsByTagName("invalid")[0];
      const isInvalid = invalidTag && invalidTag.textContent.trim() === "1";
      return !isInvalid; // Include only valid results
    });

    // Ensure the <results> parent node contains only valid results
    const resultsParent = xmlDoc.getElementsByTagName("results")[0];
    if (resultsParent) {
      // Clear all existing child nodes in <results>
      while (resultsParent.firstChild) {
        resultsParent.removeChild(resultsParent.firstChild);
      }
      // Append valid results
      validResults.forEach((result) => {
        resultsParent.appendChild(result);
      });
    }

    return xmlDoc;
  } catch (error) {
    console.error("Error fetching event details:", error);
    return null;
  }
};

export const convertTimeToMilliseconds = (timeStr) => {
  const [minutes, seconds] = timeStr.split(":").map(Number);
  const [wholeSeconds, milliseconds] = seconds.toFixed(3).split(".").map(Number);
  return minutes * 60 * 1000 + wholeSeconds * 1000 + milliseconds;
};

export const determineMedal = (lapTimeMs, thresholds) => {
  const diamondMs = convertTimeToMilliseconds(thresholds.Diamond);
  const goldMs = convertTimeToMilliseconds(thresholds.Gold);
  const silverMs = convertTimeToMilliseconds(thresholds.Silver);
  const bronzeMs = convertTimeToMilliseconds(thresholds.Bronze);

  if (lapTimeMs <= diamondMs) return { name: "Diamond", points: 5, class: "glow-diamond" };
  if (lapTimeMs <= goldMs) return { name: "Gold", points: 3, class: "glow-gold" };
  if (lapTimeMs <= silverMs) return { name: "Silver", points: 2, class: "glow-silver" };
  if (lapTimeMs <= bronzeMs) return { name: "Bronze", points: 1, class: "glow-bronze" };
  return { name: "None", points: 0, class: "" };
};

export const getEventTimings = () => eventTimings;
